import { useApi } from './useApi';
import { useAppState } from './useAppState';
import { getHttpInstance, getApiConfig } from './useApi';
export function useGoals() {
    const api = useApi();
    const state = useAppState();
    function getSavingGoals(onSuccess = null) {
        api.GET("/Customers/00000000-0000-0000-0000-000000000000/SavingsGoals", (result) => {
            state.savingGoals = result;
            if (onSuccess) {
                onSuccess(result);
            }
        }, /* useCache: */ true);
    }
    function clearSavingGoals() {
        const config = getApiConfig();
        localStorage.removeItem(config.api + (config.useCachedEndpoints ? '/Cached' : '') + '/Customers/00000000-0000-0000-0000-000000000000/SavingsGoals');
    }
    function getSavingGoal(id, onSuccess = null) {
        api.GET("/Customers/00000000-0000-0000-0000-000000000000/SavingsGoals/" + id, (result) => {
            if (onSuccess) {
                onSuccess(result);
            }
        }, /* useCache: */ true);
    }
    function deleteSavingGoal(id, onSuccess = null) {
        getHttpInstance().delete(getApiConfig().api + "/Customers/00000000-0000-0000-0000-000000000000/SavingsGoals/" + id)
            .then((response) => {
            if (onSuccess) {
                onSuccess(response.data);
            }
        })
            .catch((result) => {
            if (result.response.status == 401) {
                api.refreshLogin(() => {
                    deleteSavingGoal(id, onSuccess);
                });
            }
        });
    }
    function quoteSavingGoal(goal, onSuccess = null) {
        getHttpInstance().post(getApiConfig().api + "/Customers/00000000-0000-0000-0000-000000000000/SavingsGoals/BankAccounts/" + goal.bankAccountID + "/Quotes", goal)
            .then((response) => {
            if (onSuccess) {
                onSuccess(response.data);
            }
        })
            .catch((result) => {
            if (result.response.status == 401) {
                api.refreshLogin(() => {
                    quoteSavingGoal(goal, onSuccess);
                });
            }
        });
    }
    function createSavingGoal(goal, onSuccess = null) {
        getHttpInstance().post(getApiConfig().api + "/Customers/00000000-0000-0000-0000-000000000000/SavingsGoals/", goal)
            .then((response) => {
            if (onSuccess) {
                onSuccess(response.data);
            }
        })
            .catch((result) => {
            if (result.response.status == 401) {
                api.refreshLogin(() => {
                    createSavingGoal(goal, onSuccess);
                });
            }
        });
    }
    return {
        getSavingGoals,
        clearSavingGoals,
        getSavingGoal,
        deleteSavingGoal,
        quoteSavingGoal,
        createSavingGoal,
    };
}
